/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import Footer from "./footer"
import "./layout.scss"

const Layout = ({ children, headerMenu = "home" }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          phone
        }
      }
    }
  `)

  return (
    <>
      <Header
        siteTitle={data.site.siteMetadata.title}
        sitePhone={data.site.siteMetadata.phone}
        headerMenu={headerMenu}
      />
      <div
        style={{
          margin: `0 auto`,
          maxWidth: "100%",
          padding: `0 0 1.45rem`,
        }}
      >
        <main>{children}</main>
        <Footer
          siteTitle={data.site.siteMetadata.title}
          sitePhone={data.site.siteMetadata.phone}
        />
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
